import { configureStore, PayloadAction } from '@reduxjs/toolkit';
import {
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import { createEpicMiddleware } from 'redux-observable';
import rootReducer from './rootReducer';
import rootEpic from './epics';

/**
 * We need the PayloadAction's payload type to be "any" so that our epicMiddleware can
 * catch any incoming actions. Each individual epic will make sure to process only its
 * required actions.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const epicMiddleware = createEpicMiddleware<PayloadAction<any>>();

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(epicMiddleware), // Any additional middleware should be concatenated to this array
  devTools: process.env.NODE_ENV !== 'production',
  enhancers: [],
});

epicMiddleware.run(rootEpic);

export default store;
export type AppDispatch = typeof store.dispatch;
export const persistor = persistStore(store);
